import { makeObservable, observable } from 'mobx';
import SituacaoAcordao, { SITUACAO_ACORDAO } from '../../dominio/SituacaoAcordao';
import SituacaoAcordaoBusiness from '../../dominio/SituacaoAcordaoBusiness';
import IconeAcordaoFiltroRapido from '../../img/IconeAcordaoFiltroRapido';
import BusinessError from '../../util/BusinessError';
import ErrorUtil from '../../util/ErrorUtil';
import { Filtro } from './Filtro';

export default class FiltroSituacaoAcordao extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';

    get label() {
        return 'Situação do acórdão';
    }

    getIconeFiltroRapido() {
        return <IconeAcordaoFiltroRapido />;
    }

    opcoesFiltro = FiltroSituacaoAcordao.#carregarOpcoes();

    filtroRapido = {
        opcoes: this.getOpcoesFiltro('valor', 'cor')
    };

    static #carregarOpcoes() {
        return [
            {
                valor: SITUACAO_ACORDAO.NAO_PUBLICAVEL.id,
                cor: SITUACAO_ACORDAO.NAO_PUBLICAVEL.cor,
                icone: (
                    <IconeAcordaoFiltroRapido
                        style={{ fill: SITUACAO_ACORDAO.NAO_PUBLICAVEL.cor, fillOpacity: '0.7', padding: '2px' }}
                    />
                )
            },
            {
                valor: SITUACAO_ACORDAO.NAO_ASSINADO.id,
                cor: SITUACAO_ACORDAO.NAO_ASSINADO.cor,
                icone: (
                    <IconeAcordaoFiltroRapido
                        style={{ fill: SITUACAO_ACORDAO.NAO_ASSINADO.cor, fillOpacity: '0.7', padding: '2px' }}
                    />
                )
            },
            {
                valor: SITUACAO_ACORDAO.ASSINADO_ORIGEM.id,
                cor: SITUACAO_ACORDAO.ASSINADO_ORIGEM.cor,
                icone: (
                    <IconeAcordaoFiltroRapido
                        style={{ fill: SITUACAO_ACORDAO.ASSINADO_ORIGEM.cor, fillOpacity: '0.7', padding: '2px' }}
                    />
                )
            },
            {
                valor: SITUACAO_ACORDAO.ASSINADO_E_NAO_VERIFICADO.id,
                cor: SITUACAO_ACORDAO.ASSINADO_E_NAO_VERIFICADO.cor,
                icone: (
                    <IconeAcordaoFiltroRapido
                        style={{
                            fill: SITUACAO_ACORDAO.ASSINADO_E_NAO_VERIFICADO.cor,
                            fillOpacity: '0.7',
                            padding: '2px'
                        }}
                    />
                )
            },
            {
                valor: SITUACAO_ACORDAO.DEVOLVIDO_PARA_CORRECAO.id,
                cor: SITUACAO_ACORDAO.DEVOLVIDO_PARA_CORRECAO.cor,
                icone: (
                    <IconeAcordaoFiltroRapido
                        style={{
                            fill: SITUACAO_ACORDAO.DEVOLVIDO_PARA_CORRECAO.cor,
                            fillOpacity: '0.7',
                            padding: '2px'
                        }}
                    />
                )
            },
            {
                valor: SITUACAO_ACORDAO.ASSINADO_E_VERIFICADO.id,
                cor: SITUACAO_ACORDAO.ASSINADO_E_VERIFICADO.cor,
                icone: (
                    <IconeAcordaoFiltroRapido
                        style={{
                            fill: SITUACAO_ACORDAO.ASSINADO_E_VERIFICADO.cor,
                            fillOpacity: '0.7',
                            padding: '2px'
                        }}
                    />
                )
            }
        ];
    }

    constructor(props) {
        super(props);

        makeObservable(this, {
            filtroRapido: observable
        });
    }

    getValorOpcao(registro) {
        let situacaoAcordao;

        try {
            situacaoAcordao = SituacaoAcordaoBusiness.getSituacaoAcordaoEscopoPublicacao(registro);
        } catch (e) {
            if (e instanceof BusinessError) {
                if (
                    e.message.indexOf(
                        SituacaoAcordaoBusiness.MSG_ERRO_IDENTIFICACAO_SITUACAO_ACORDAO_PUBLICACAO_PROCESSO_NAO_JULGADO
                    ) === -1
                ) {
                    console.warn(e.message);
                }
            } else {
                console.error(ErrorUtil.montarMensagemErro(e));
            }

            return '';
        }

        return situacaoAcordao.id;
    }

    getDescricao(valor) {
        return SituacaoAcordao.getDescricao(valor);
    }
}
